/**
 * The ViewRenderState enum represents the render state of a particular view.
 * It applies to components that explicitly fetch data.
 */ export var ViewRenderState;
(function(ViewRenderState) {
    // All data is rendered within the component
    ViewRenderState[ViewRenderState["All"] = 2] = "All";
    // Visually critical data sufficient to make the component feel loaded is rendered
    ViewRenderState[ViewRenderState["Critical"] = 1] = "Critical";
    // No data is yet rendered and the view is empty
    ViewRenderState[ViewRenderState["None"] = 0] = "None";
})(ViewRenderState || (ViewRenderState = {}));
export var ViewDataFetchState;
(function(ViewDataFetchState) {
    // The data fetch is started
    ViewDataFetchState[ViewDataFetchState["Started"] = 0] = "Started";
    // The data fetch is completed
    ViewDataFetchState[ViewDataFetchState["Completed"] = 1] = "Completed";
})(ViewDataFetchState || (ViewDataFetchState = {}));
export var ViewName;
(function(ViewName) {
    ViewName["PlanPage"] = "PlanPage";
    ViewName["LeftNavContainer"] = "LeftNavContainer";
    ViewName["UnoLeftNavContainer"] = "UnoLeftNavContainer";
    ViewName["MyDayPage"] = "MyDayPage";
    ViewName["MyTasksPage"] = "MyTasksPage";
    ViewName["MyPlansPage"] = "MyPlansPage";
    ViewName["MyPortfoliosPage"] = "MyPortfoliosPage";
    ViewName["PortfolioPage"] = "PortfolioPage";
    ViewName["BasicPlanPage"] = "BasicPlanPage";
    ViewName["TaskEditorContainer"] = "TaskEditorContainer";
    ViewName["CreateTeamsTabPage"] = "CreateTeamsTabPage";
    ViewName["CreateTaskPage"] = "CreateTaskPage";
    ViewName["RemoveTeamsTabPage"] = "RemoveTeamsTabPage";
    ViewName["TeamsTabLandingExperienceContainer"] = "TeamsTabLandingExperienceContainer";
    ViewName["PremiumPlanPage"] = "PremiumPlanPage";
    ViewName["ConfigTeamsTabPage"] = "ConfigTeamsTabPage";
    ViewName["NewTabPage"] = "NewTabPage";
    ViewName["PublishingPage"] = "PublishingPage";
    ViewName["UnifiedPlanPage"] = "UnifiedPlanPage";
    ViewName["CreatePlanModal"] = "CreatePlanModal";
    ViewName["CreatePortfolioModal"] = "CreatePortfolioModal";
    ViewName["SharePlanDialog"] = "SharePlanDialog";
    ViewName["CopyPlanModal"] = "CopyPlanModal";
    ViewName["SuiteNavContainer"] = "SuiteNavContainer";
    ViewName["PlannerShell"] = "PlannerShell";
    ViewName["MessageTasks"] = "MessageTasks";
})(ViewName || (ViewName = {}));
export var EmptyStateViewType;
(function(EmptyStateViewType) {
    /** Empty state view for no plans */ EmptyStateViewType["NoPlansAvailable"] = "noPlansAvailable";
    /** Empty state view for no plans found */ EmptyStateViewType["NoPlansFound"] = "noPlansFound";
    /** Service error empty state view */ EmptyStateViewType["ServiceError"] = "serviceError";
    /** Empty state view for no portfolios available */ EmptyStateViewType["NoPortfoliosAvailable"] = "noPortfoliosAvailable";
    /** Empty state view for no tasks found for applied filters */ EmptyStateViewType["NoTasksFoundForAppliedFilters"] = "noTasksFoundForAppliedFilters";
})(EmptyStateViewType || (EmptyStateViewType = {}));
export var ViewDisplayState;
(function(ViewDisplayState) {
    /** Data is available regardless of filters */ ViewDisplayState["DataAvailable"] = "DA";
    /** Data is available but filtered out completely */ ViewDisplayState["DataAvailableButFiltered"] = "DAF";
    /** Data is not available after fetching */ ViewDisplayState["DataNotAvailable"] = "DNA";
    /** Data is not fetched (being fetched) */ ViewDisplayState["DataNotFetched"] = "DNF";
})(ViewDisplayState || (ViewDisplayState = {}));
